/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import {HISTORY, Solution} from '@exc/core/src/models/Solution';

const sideNav = {workHubId: 'LAUNCH'};
// NOTE: Reason for missing `serviceCode` and empty `access`:
// All companies have Launch but users have to be given permission as assigned by an Org Admin.
// If you visit Launch without having any permissions, the app
// will tell you to contact your Org Admin.
export const launch: Solution = {
  appId: 'launch',
  distributionList: ['activation-engineering@adobe.com'],
  name: 'Launch',
  path: '/launch',
  analytics: {code: 'launch'},
  gainsight: {productKey: 'AP-ICU715RZNQ41-2'},
  sandbox: {
    hideInitialSpinner: true,
    history: HISTORY.HISTORY,
    ims: {
      client_id: 'Activation-DTM',
      scope: 'openid,AdobeID,session,read_organizations,additional_info.projectedProductContext,additional_info.job_function,additional_info.roles,audiencemanager_api'
    },
    sources: {
      dev: 'https://localhost:9002',
      dev1: 'https://lens-dev.launch.adobe.net',
      qa: 'https://lens-qe1.launch.adobe.net',
      integration: 'https://launch-integration.adobe.com',
      stage: 'https://launch-stage.adobe.com',
      demo: 'https://launch-demo.adobe.com',
      prod: 'https://launch.adobe.com'
    }
  }
};

export const launchDataCollection: Solution = {
  appId: 'launchDataCollection',
  distributionList: ['activation-engineering@adobe.com'],
  name: 'Data Collection',
  path: '/data-collection',
  analytics: {code: 'launch'},
  gainsight: {productKey: 'AP-ICU715RZNQ41-2'},
  sandbox: {
    hideInitialSpinner: true,
    history: HISTORY.HISTORY,
    ims: {
      client_id: 'Activation-DTM',
      scope: 'openid,AdobeID,session,read_organizations,additional_info.projectedProductContext,additional_info.job_function,additional_info.roles,audiencemanager_api'
    },
    sources: {
      dev: 'https://localhost:9002',
      dev1: 'https://lens-dev.launch.adobe.net',
      qa: 'https://lens-qe1.launch.adobe.net',
      nav: 'https://lens-preview-lens-1148-workhub-changes.ethos12-stage-va6.ethos.adobe.net',
      integration: 'https://launch-integration.adobe.com',
      stage: 'https://launch-stage.adobe.com',
      demo: 'https://launch-demo.adobe.com',
      prod: 'https://launch.adobe.com'
    }
  },
  sideNav,
  urlContext: {key: 'sandbox'}
};

export const launchPlatform: Solution = {
  appId: 'launch-platform',
  distributionList: [`Grp-platform-ui@adobe.com`],
  path: '/data-collection/platform',
  serviceCode: 'acp',
  sandbox: {
    history: HISTORY.HISTORY,
    sources: {
      dev: 'https://localhost.dev.cloud.adobe.io',
      qa: 'https://platform-int.adobe.com',
      stage: 'https://platform-stage.adobe.com',
      prod: 'https://platform.adobe.com'
    }
  },
  sideNav,
  urlContext: {key: 'sandbox'}
};
